module.exports = __webpack_public_path__ + "img/transit.1b4758fc.gif";